import { Map as FileMap } from './file';

export class QuiculumMap {
  static to   = FileMap.to;
  static File = FileMap;
}